<template>
  <div class="cake-con-conform-0311">
    <div class="header">
      <div class="title">请确认配送信息</div>
    </div>
    <div class="form">
      <form ref="submitFormRef">
        <van-field :value="staffNames" label="已选员工" readonly />
        <van-field :value="cakeName" label="已选蛋糕" readonly />
        <div class="cut"></div>
        <van-field
          @click="addressPicker.show = true"
          name="picker"
          label="选择地址"
          placeholder="点击选择地址"
          readonly
          clickable
          is-link
        >
          <template #input>
            <span>{{formData.contactsAddress}}</span>
          </template>
        </van-field>
        <van-field
          :value="formData.deliveryTime"
          @click="deliveryTimePicker.show = true"
          class="datetime"
          name="datetimePicker"
          label="配送时间"
          placeholder="选择配送时间"
          error-message="11:00前可选明天配送, 否则最快2天后配送"
          clickable
          readonly
          is-link
        />
        <van-field v-model="formData.contactsName" name="联系人" label="联系人" placeholder="联系人" />
        <van-field v-model="formData.contactsPhone" name="联系电话" label="联系电话" placeholder="联系电话" />
      </form>
    </div>
    <!--  -->
    <van-popup v-model="addressPicker.show" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        :columns="addressPicker.data"
        @confirm="addressPickerConfirm"
        @cancel="addressPicker.show = false"
      />
    </van-popup>
    <van-popup v-model="deliveryTimePicker.show" position="bottom" get-container="body">
      <van-datetime-picker
        :formatter="formatter"
        :min-date="deliveryTimePicker.min"
        @confirm="deliveryTimePickerConfirm"
        @cancel="deliveryTimePicker.show = false"
        type="date"
      />
    </van-popup>
  </div>
</template>

<script>

import { Form, Field as VanField, DatetimePicker as VanDatetimePicker, Picker as VanPicker, Popup as VanPopup } from 'vant';
import { formatShortDate } from '@utils/date.js';
import { queryContactsAddress } from '@/api/birthday';

export default {

  components: {
    Form,
    VanField,
    VanDatetimePicker,
    VanPicker,
    VanPopup,
  },

  props: ['orderInfo'],

  data() {
    return {
      formData: {
        contactsAddress: '', // 收货地址
        deliveryTime: '', // 配送时间
        contactsName: '', // 联系人
        contactsPhone: '', // 联系电话
        jobMarketId: '',
      },
      addressPicker: {
        show: false,
        data: [],
      },
      deliveryTimePicker: {
        show: false,
        min: new Date(),
      },
    };
  },

  mounted() {
    this.initContactsAddress();
  },

  computed: {

    // 过生日的员工姓名
    staffNames() {
      if (!this.orderInfo.staff) {
        return '';
      }
      return this.orderInfo.staff.map(staff => staff.personName).join(', ');
    },

    cakeName() {
      if (!this.orderInfo.cake) {
        return '';
      }
      return this.orderInfo.cake.commodityName;
    },
  },

  methods: {

    init() {
      // 计算开始时间
      this.getStartTime();
      // 填入当前登录人信息
      this.formData.contactsName = this.orderInfo.staff[0].leaderPersonName;
      // this.formData.contactsPhone = this.orderInfo.staff[0].leaderPersonPhone;
    },

    /**
     * 查询配送地址
     */
    initContactsAddress() {
      queryContactsAddress().then(res => {
        this.addressPicker.data = res;
      }).catch(({ message = '系统异常' }) => {
        this.$toast(message);
      });
    },

    canSubmit() {
      if (!this.formData.contactsAddress) {
        this.$toast('请选择地址');
        return null;
      }

      if (!this.formData.deliveryTime) {
        this.$toast('请选择配送时间');
        return null;
      }

      if (!this.formData.contactsName) {
        this.$toast('请输入联系人');
        return null;
      } else if (!/^[\u4e00-\u9fa5]{1,6}$/.test(this.formData.contactsName)) {
        this.$toast('请填写正确的联系人');
        return null;
      }

      if (!this.formData.contactsPhone) {
        this.$toast('请填写联系电话');
        return null;
      } else if (!/^1[0-9]{10}/.test(this.formData.contactsPhone)) {
        this.$toast('请填写正确的联系电话');
        return null;
      }

      return this.formData;
    },

    /**
     * 获取配送开始时间
     * 
     * 11:00前订最快明天配送, 11:00后订最快2天后配送
     */
    getStartTime() {
      const nowDate = new Date();
      if (nowDate.getHours() >= 11) {
        nowDate.setDate(nowDate.getDate() + 2)
      } else {
        nowDate.setDate(nowDate.getDate() + 1)
      }
      this.deliveryTimePicker.min = nowDate;
      // this.formData.deliveryTime = formatShortDate(nowDate);
      return nowDate;
    },

    addressPickerConfirm(e) {
      this.formData.jobMarketId = e.id;
      this.formData.contactsAddress = e.value;
      this.addressPicker.show = false;
    },

    deliveryTimePickerConfirm(e) {
      this.formData.deliveryTime = formatShortDate(e);
      this.deliveryTimePicker.show = false;
    },

    /**
     * 格式化日期组件
     */
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.form {
  margin-top: 40px;
  .cut {
    width: 100%;
    height: 6px;
    background: repeating-linear-gradient(
      -45deg,
      #ff6c6c 0,
      #ff6c6c 20%,
      transparent 0,
      transparent 25%,
      #1989fa 0,
      #1989fa 45%,
      transparent 0,
      transparent 50%
    );
    background-size: 80px;
    margin-bottom: 40px;
  }
}
</style>
<style lang="scss">
.cake-con-conform-0311 .datetime .van-field__error-message {
  font-size: 10px;
  line-height: 16px;
  color: #faab0c;
}
</style>
